import { useEffect, useState } from 'react';

/**
 * Whether the server has guest notifications switched on for this venue (PUSH_ENABLED_VENUES).
 * null while unknown (loading or the request failed), so menus stay hidden until it is a clear yes.
 */
export default function usePushEnabled(venueId, roleType = 'venue') {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    setEnabled(null);
    if (!venueId || roleType !== 'venue') return undefined;
    let current = true;
    fetch(`${process.env.REACT_APP_API_BASE_URL}/public/push/${encodeURIComponent(venueId)}/enabled`)
      .then(res => (res.ok ? res.json() : null))
      .then(data => { if (current) setEnabled(typeof data?.enabled === 'boolean' ? data.enabled : null); })
      .catch(() => { if (current) setEnabled(null); });
    return () => { current = false; };
  }, [venueId, roleType]);

  return enabled;
}
